import style from "./footer.module.css";
import Image from "next/image";
import Link from "next/link";
import DropLeadForm from "@/components/common/droplead-form/droplead_form";
import SocialMedia from "@/components/common/social-media/social_media";
import Button from "@/components/UI/button/button";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import CustomerContext from "@/stores/customer-context";
import useGtm, { GTM_EVENT } from "@/hooks/useGtm";
import { useCookies } from "react-cookie";
import { hash } from "@/helpers/utility/crypto";
import { ConsentPrivacyPolicy } from "../common/consent-privacy-policy/consent_privacy_policy";
import { isEmpty } from "underscore";

export default function Footer({ no_nav = false }) {
  const customerCtx = useContext(CustomerContext);
  const { onSendGtmEvent } = useGtm();
  const footerDropLeadRef = useRef();
  const [isDropLeadCta, setIsDropLeadCta] = useState(true);
  const [cookies, setCookie, removeCookie] = useCookies(["cookie-name"]);
  const [isPdpaConsent, setIsPdpaConsent] = useState(false);
  const [clickSubmit, setClickSubmit] = useState(false);
  const [footerConsentSubmit, setFooterConsentSubmit] = useState(false);
  const onSubmitHandler = async (customerDropleadInfo) => {
    try {
      await customerCtx.setCustomerInfo(customerDropleadInfo, "droplead");
      const hashedPhone = await hash(customerDropleadInfo.phone);
      const _userId = await customerCtx.getUserId();
      const gtmEvent = {
        transaction_id: _userId,
        phone: hashedPhone,
      };
      onSendGtmEvent(GTM_EVENT.DROP_LEAD, gtmEvent, "footer");
      alert(
        "ท่านได้ส่งข้อมูลเพื่อให้พนักงานติดต่อกลับเรียบร้อยแล้ว บริษัทจะติดต่อกลับท่านเพื่อให้บริการ"
      );
      setTimeout(() => {
        setFooterConsentSubmit(true);
      }, 1000);
    } catch (err) {
      console.warn(err.message);
    }
  };

  useEffect(() => {
    (async () => {
      window.addEventListener("scroll", onScrollHandler);
      const pdpaConsent = cookies["consent"] || false;
      setIsPdpaConsent(pdpaConsent);
    })();
  }, []);
  const onScrollHandler = () => {
    if (!footerDropLeadRef.current) return;
    const windowOffset = window.pageYOffset;
    const viewPortY = window.innerHeight;
    const dropLeadElementOffset = footerDropLeadRef.current.offsetTop;
    if (windowOffset + viewPortY > dropLeadElementOffset) {
      setIsDropLeadCta(false);
    } else {
      setIsDropLeadCta(true);
    }
  };
  const dropLeadCtaOnClickHandler = () => {
    window.scrollTo({
      top: footerDropLeadRef.current.offsetTop,
      behavior: "smooth",
    });
  };
  const onConsentChangeHandler = (e, setFieldValue, errors) => {
    setFieldValue("consent", e.target.checked);
  };
  const onPdpaConsentHandler = () => {
    const maxAge = 1000 * 60 * 60 * 24 * 7;
    setCookie("consent", true, {
      maxAge: maxAge,
      sameSite: "strict",
      path: "/",
    });
    setIsPdpaConsent(true);
    // window.document.cookie = `consent=true;max-age=${maxAge};sameSite=strict`;
  };

  return (
    <footer>
      <section
        className={`${style.pdpa_consent_section} ${
          isPdpaConsent ? "hidden" : ""
        }`}
      >
        <div className={style.pdpa_consent_container}>
          <div className={style.pdpa_content_wrapper}>
            <p>
              เว็บไซต์นี้ใช้คุกกี้
              เพื่อให้ท่านสามารถใช้บริการได้อย่างต่อเนื่องและอำนวยความสะดวกในการใช้งานเว็บไซต์
              รวมถึงช่วยให้เราปรับปรุงการนำเสนอเนื้อหาตรงตามวัตถุประสงค์ความต้องการของท่าน
              โดยสามารถศึกษารายละเอียดเพิ่มเติมได้ใน
              <span>
                <a href="/policy/cookies" target={"_blank"}>
                  &nbsp;นโยบายคุกกี้ (Cookie Policy)
                </a>
                ,
              </span>
              <span>
                <a href="/policy/term-and-condition">
                  &nbsp;นโยบายคุ้มครองข้อมูลส่วนบุคคล (Data Privacy Policy)
                </a>
                และ
              </span>
              <span>
                <a href="/policy/pdpa">
                  &nbsp;แจ้งการเก็บรวบรวมใช้เปิดเผยข้อมูลส่วนบุคคล
                </a>
              </span>
            </p>
          </div>
          <div className={style.pdpa_button_wrapper}>
            <Button
              text="ยอมรับ"
              color="darkblue"
              onClick={onPdpaConsentHandler}
            />
          </div>
        </div>
      </section>
      <div
        className={`${style.drop_lead_cta} ${isDropLeadCta ? "" : style.hide}`}
        onClick={dropLeadCtaOnClickHandler}
      >
        <span>สนใจทำประกัน</span>
        <img alt="arrow-down" src="/assets/icon-svg/box-arrow-down.svg" />
      </div>
      <section className={style.footer_drop_lead_section}>
        <div
          className={style.footer_drop_lead_container}
          ref={footerDropLeadRef}
        >
          <h3>สนใจทำประกันภัยฝากข้อมูลของคุณเพื่อให้เราติดต่อกลับ</h3>
          <div className={style.drop_lead}>
            <DropLeadForm
              theme="blue"
              onSubmit={onSubmitHandler}
              parentClass={style.droplead_form}
            >
              {(
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                Field,
                setFieldValue
              ) => (
                <Fragment>
                  <Field
                    fieldName="firstName"
                    fieldTitle="ชื่อ"
                    fieldPlaceHolder="โปรดระบุชื่อ"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    parentClass={style.field}
                    theme="outline"
                  />
                  <Field
                    fieldName="lastName"
                    fieldTitle="นามสกุล"
                    fieldPlaceHolder="โปรดระบุนามสกุล"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    parentClass={style.field}
                    theme="outline"
                  />
                  <Field
                    fieldName="phone"
                    maxlength="10"
                    fieldTitle="เบอร์โทรศัพท์"
                    fieldPlaceHolder="โปรดระบุเบอร์โทรศัพท์"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    parentClass={style.field}
                    theme="outline"
                  />
                  {!footerConsentSubmit && (
                    <ConsentPrivacyPolicy
                      clickSubmit={clickSubmit}
                      setClickSubmit={setClickSubmit}
                      onSubmit={() => onSubmitHandler(values)}
                    />
                  )}
                  <div className={style.submit_wrapper}>
                    <Button
                      color="blue"
                      text="ส่ง"
                      onClick={(e) => {
                        if (isEmpty(errors) && !isEmpty(touched)) {
                          e.preventDefault();
                          setClickSubmit(true);
                        }
                      }}
                    />
                  </div>
                </Fragment>
              )}
            </DropLeadForm>
          </div>
        </div>
      </section>
      {!no_nav && (
        <nav className={style.footer_nav_section}>
          <div className={style.footer_nav_container}>
            <div className={style.nav_bar}>
              <ul className={style.nav}>
                <li>
                  <Link href="/products">
                    <a>แผนประกันบ้าน</a>
                  </Link>
                </li>
                <li>
                  <Link href="/calculate-plan/home-info">
                    <a>คำนวณเบี้ยประกัน</a>
                  </Link>
                </li>
                <li>
                  <Link href="/articles">
                    <a>เรื่องบ้านน่ารู้</a>
                  </Link>
                </li>
                {/* <li>
                  <Link href="/faq">
                    <a>คำถามที่พบบ่อย</a>
                  </Link>
                </li>
                <li>
                  <Link href="/">
                    <a>เกี่ยบกับเรา</a>
                  </Link>
                </li>
                <li>
                  <Link href="/">
                    <a>ติดต่อเรา</a>
                  </Link>
                </li> */}
              </ul>
            </div>
            <div className={style.social_media}>
              <h5>Social Medias:</h5>
              <SocialMedia />
            </div>
          </div>
        </nav>
      )}
      <section className={style.footer_contact_section}>
        <div className={style.footer_contact_container}>
          <div className={style.footer_contact_wrapper}>
            <figure className={style.logo_wrapper}>
              <Image
                alt="tqm-logo"
                src="/assets/icon-svg/tqm-logo-white.svg"
                width={93}
                height={31}
              />
            </figure>
            <address className={style.address}>
              <p>
                บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์ จำกัด <br />
                123 ถนนลาดปลาเค้า แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพฯ 10230
              </p>
            </address>
            <div className={style.contact_info}>
              <p>
                โทร : 1737 (24 ชม.) 02 119 8888 <br />
                โทรสาร : 02 119 8800, Email : info@tqm.co.th
              </p>
            </div>
            <div className={style.social_media}>
              <h5>Social Medias:</h5>
              <SocialMedia />
            </div>
            <div className={style.award}>
              <figure>
                <Image
                  src="/assets/images/award.png"
                  width={116}
                  height={57}
                  layout="fixed"
                />
              </figure>
              <p>
                รางวัลการันตี
                <br />
                การันตีความเชื่อมั่นจากคปภ.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={style.footer_verified_section}>
        <div className={style.footer_verified_container}>
          <ul className={style.credential_wrapper}>
            <li>
              <img
                alt="ใบอนุญาตจากกรมพัฒนาธุรกิจการค้า"
                src="/assets/icon-png/logo-license-1.png"
              />
              <p>ใบอนุญาตจากกรมพัฒนาธุรกิจการค้า เลขที่ 0105540084143</p>
            </li>
            <li>
              <img
                alt="ใบอนุญาตนายหน้าประกันวินาศภัย"
                src="/assets/icon-png/logo-license-2.png"
              />
              <p>ใบอนุญาตนายหน้าประกันวินาศภัย เลขที่ ว00019/2546</p>
            </li>
            <li>
              <img
                alt="ใบรับรองความปลอดภัยทางอิเล็กทรอนิกส์"
                src="/assets/icon-png/logo-license-3.png"
              />
              <p>ใบรับรองความปลอดภัยทางอิเล็กทรอนิกส์ </p>
            </li>
          </ul>
        </div>
      </section>
    </footer>
  );
}
